import { Label, Message } from 'semantic-ui-react';
import { getChannelOption } from './helper';
import React from 'react';

export function renderText(text, limit) {
  if (text.length > limit) {
    return text.slice(0, limit - 3) + '...';
  }
  return text;
}

export function renderGroup(group) {
  if (group === '') {
    return <Label>default</Label>;
  }
  let groups = group.split(',');
  groups.sort();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '2px',
        rowGap: '6px',
      }}
    >
      {groups.map((group) => {
        if (group === 'vip' || group === 'pro') {
          return <Label color='yellow'>{group}</Label>;
        } else if (group === 'svip' || group === 'premium') {
          return <Label color='red'>{group}</Label>;
        }
        return <Label>{group}</Label>;
      })}
    </div>
  );
}

export function renderNumber(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 10000) {
    return (num / 1000).toFixed(1) + 'k';
  } else {
    return num;
  }
}

const DEFAULT_QUOTA_PER_UNIT = 1000000 / 92;
const SEEDANCE_RMB_PER_MILLION_TOKENS = 92;
const SEEDANCE_TOKENS_PER_MILLION = 1000000;

function getQuotaPerUnit() {
  const quotaPerUnit = parseFloat(
    localStorage.getItem('quota_per_unit') || `${DEFAULT_QUOTA_PER_UNIT}`
  );
  return quotaPerUnit > 0 ? quotaPerUnit : DEFAULT_QUOTA_PER_UNIT;
}

function normalizeModelScope(models) {
  if (Array.isArray(models)) {
    return models;
  }
  if (typeof models === 'string') {
    return models
      .split(',')
      .map((model) => model.trim())
      .filter((model) => model !== '');
  }
  return [];
}

function normalizeModelOptions(modelOptions) {
  if (!Array.isArray(modelOptions)) {
    return [];
  }
  return modelOptions
    .map((option) => option?.value || option?.text || option)
    .filter((model) => model !== undefined && model !== null);
}

export function hasSeedanceModelScope(models, modelOptions = []) {
  const selectedModels = normalizeModelScope(models);
  if (selectedModels.length > 0) {
    return selectedModels.every((model) =>
      String(model).toLowerCase().includes('seedance')
    );
  }

  return normalizeModelOptions(modelOptions).some((model) =>
    String(model).toLowerCase().includes('seedance')
  );
}

function seedanceQuotaAmount(quota) {
  const rmbPerMillion = parseFloat(
    localStorage.getItem('seedance_rmb_per_million_tokens') ||
      `${SEEDANCE_RMB_PER_MILLION_TOKENS}`
  );
  const unitPrice =
    Number.isFinite(rmbPerMillion) && rmbPerMillion > 0
      ? rmbPerMillion
      : SEEDANCE_RMB_PER_MILLION_TOKENS;
  return (
    (Number(quota || 0) * unitPrice) /
    SEEDANCE_TOKENS_PER_MILLION
  );
}

export function renderQuota(quota, t, precision = 2) {
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';
  const quotaPerUnit = getQuotaPerUnit();

  if (displayInCurrency) {
    const amount = (quota / quotaPerUnit).toFixed(precision);
    return t('common.quota.display_short', { amount });
  }

  return renderNumber(quota);
}

export function renderModelQuota(
  quota,
  t,
  models,
  precision = 2,
  modelOptions = []
) {
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';

  if (displayInCurrency && hasSeedanceModelScope(models, modelOptions)) {
    const amount = seedanceQuotaAmount(quota).toFixed(precision);
    return t('common.quota.display_short', { amount });
  }

  return renderQuota(quota, t, precision);
}

export function renderQuotaWithPrompt(quota, t) {
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';
  const quotaPerUnit = getQuotaPerUnit();

  if (displayInCurrency) {
    const amount = (quota / quotaPerUnit).toFixed(2);
    return ` (${t('common.quota.display', { amount })})`;
  }

  return '';
}

export function renderModelQuotaWithPrompt(
  quota,
  t,
  models,
  modelOptions = []
) {
  const displayInCurrency =
    localStorage.getItem('display_in_currency') === 'true';

  if (displayInCurrency && hasSeedanceModelScope(models, modelOptions)) {
    const amount = seedanceQuotaAmount(quota).toFixed(2);
    return ` (${t('common.quota.seedance_display', { amount })})`;
  }

  return renderQuotaWithPrompt(quota, t);
}

const colors = [
  'red',
  'orange',
  'yellow',
  'olive',
  'green',
  'teal',
  'blue',
  'violet',
  'purple',
  'pink',
  'brown',
  'grey',
  'black',
];

export function renderColorLabel(text) {
  let hash = 0;
  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }
  let index = Math.abs(hash % colors.length);
  return (
    <Label basic color={colors[index]}>
      {text}
    </Label>
  );
}

export function renderChannelTip(channelId) {
  let channel = getChannelOption(channelId);
  if (channel === undefined || channel.tip === undefined) {
    return <></>;
  }
  return (
    <Message>
      <div dangerouslySetInnerHTML={{ __html: channel.tip }}></div>
    </Message>
  );
}
